import { CircleCheckBig } from 'lucide-react';
import styles from './CadastroSucesso.module.scss';
import { Link } from 'react-router-dom';

export const CadastroSucesso = () => {
  return (
    <div className={styles.page}>
      <div className={styles.containerLogado}>
        <CircleCheckBig className={styles.iconSucesso} size={30} />

        <h2 className={styles.title}>
          Cadastro realizado com sucesso!
        </h2>

        <p className={styles.text}>
          Agora você já pode acessar sua conta.
        </p>

        <Link to="/login">
          <button className={styles.btnFinalizar}>
            Ir para login
          </button>
        </Link>
      </div>
    </div>
  );
};